import type { ApiVolopPromotionSelected } from '#/modules/listing/volops/api/types/ApiVolopPromotionSelected';
import type { SearchAlgoliaVolopHit } from '#/modules/search/algolia/types/SearchAlgoliaVolopHit';
import { postJson } from '#/utils/http/postJson';

type ApiResponse = {
  listingPromo: {
    volopHit: SearchAlgoliaVolopHit;
    promotionSelected: ApiVolopPromotionSelected;
  } | null;
};

export async function searchApiFetchPromotedVolop(latLng: {
  latitude: number | null | undefined;
  longitude: number | null | undefined;
}): Promise<ApiResponse> {
  return postJson('/data/website/promoted-listing-for-search', latLng);
}
